import { theme } from '@slal/ui/theme';

export const calculateAxisValue = (axis: string, value: number, maxValue: number, svgDimension: number) => {
    if (maxValue === 0) return 0;
    const percentage = value / maxValue;
    return axis === 'y' ? svgDimension - percentage * svgDimension : percentage * svgDimension;
};

export type ChartConfig = {
    label: string;
    route: string;
    color: string;
};

export const CHART_CONFIG: ChartConfig[] = [
    { label: 'State pension', route: '/state-pension', color: '#147CB3' },
    { label: 'Final salary', route: '/final-salary', color: '#C78FA3' },
    { label: 'Other income', route: '/other-income', color: '#FFBF73' },
    { label: 'Annuity', route: '/annuity', color: '#8454A4' },
    { label: 'Drawdown', route: '/drawdown', color: '#00A799' },
];

export const getAlertColors = () => {
    return { warning: theme.colors.orange__00, success: theme.colors.green__00 };
};
